import { TextField } from '@mui/material'
import React from 'react'

function TableTxtField({ name, title, placeholder, type, color, errMsg, marginTop, marginBottom, defaultValue, bgColor,
    readOnly, disabled, multiline, height, rows, width, endAdornment, fontSize, startAdornment, borderRadius, value, onChange }) {

    return (
        <TextField variant="outlined"
            InputProps={{
                readOnly: readOnly,
                disabled: disabled,
                multiline: multiline,
                rows: rows ? rows : 1,
                endAdornment: endAdornment,
                startAdornment: startAdornment
            }}
            sx={{
                "& .MuiInputBase-root": {
                    height: height ? height : 35,
                    width: width ? width : "100%",
                    borderRadius: borderRadius ? borderRadius : 2,
                    fontSize: fontSize || 12,
                    marginTop: marginTop || 0.4,
                    marginBottom: marginBottom || 1,
                    color: color || "rgba(0, 0, 0, 1)",
                    backgroundColor: bgColor ? bgColor : "#ffff",
                },
            }}
            fullWidth size="small" placeholder={placeholder ? placeholder : title} name={name} type={type} defaultValue={defaultValue}
            id={title}
            error={errMsg && true}
            helperText={errMsg && errMsg}
            value={value}
            onChange={onChange}
        />
    )
}

export default TableTxtField